
import React from "react";
import * as react from "react";
import { defaultArg, unwrap, map } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { Point_toPosition } from "./Shared.js";
import { FSharpMap__TryFind } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { empty } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { RotatedMarker } from "../../../src/StenaWeather.WeatherServiceUI.Client/Components/Leaflet/RotatedMarker.js";

export function Marker_View($props) {
    const p = $props.p;
    let props;
    const position = map(Point_toPosition, map((x) => x, FSharpMap__TryFind(p, "position")));
    props = {
        icon: map((x_1) => x_1, FSharpMap__TryFind(p, "icon")),
        position: unwrap(position),
        rotationAngle: map((x_2) => x_2, FSharpMap__TryFind(p, "rotationAngle")),
        rotationOrigin: map((x_3) => x_3, FSharpMap__TryFind(p, "rotationOrigin")),
        zIndexOffset: map((x_4) => x_4, FSharpMap__TryFind(p, "zIndexOffset")),
    };
    const children = defaultArg(map((x_5) => x_5, FSharpMap__TryFind(p, "children")), empty());
    return react.createElement(RotatedMarker, props, ...children);
}

